import licenseModule from '../../license.module';

export default licenseModule.component('licenseServerDetails', {
    template: require('./licenseServerDetails.component.html'),
    controller: licenseServerDetailsComponent,
    bindings: {
        name: '<',
        description: '<',
        countryCode: '<',
        callback: '&'
    }
});

function licenseServerDetailsComponent() {
    var vm = this;

    vm.minLength = 1;
    vm.maxLength = 100;

    vm.changes = function() {
        var value = {
            name: vm.name,
            description: vm.description,
            countryCode: vm.countryCode
        };
        vm.callback({ value: value });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-server-details/licenseServerDetails.component.js